import { AuthService } from "@brainspore/celadon-base/modules/auth";
import SettingConstants from "./SettingConstants";
import { call } from "@brainspore/celadon-base/service";

export default {
  namespaced: true,
  state: {
    recentActivities: [],
    accountSettings: {},
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    settingGetter: (state) => (setup) => state[setup],
  },
  actions: {
    setActions: ({ commit }) => {
      if (AuthService.check()) {
        commit("Dashboard/SET_ACTIONS");
      }
    },
    // Recently visited pages
    recentActivity: ({ commit }) => {
      call("get", SettingConstants.LOGS_URL)
        .then((response) => {
          commit("MUTATE", {
            state: "recentActivities",
            data: response.data.data,
          });
          Event.$emit("ApiSuccess", response.data.message);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // Add recent activity
    // eslint-disable-next-line no-empty-pattern
    addRecentActivity: ({}, payload) => {
      call("post", SettingConstants.LOGS_URL, payload)
        .then(() => {
          // Event.$emit("ApiSuccess", response.data.message);
        })
        .catch(() => {
          // Event.$emit("ApiError", error.response.data.message);
        });
    },
    // get account settings
    currentUser: ({ commit }) => {
      let user = `${process.env.VUE_APP_NAME}_user`;
      commit("MUTATE", {
        state: "accountSettings",
        data: JSON.parse(window.localStorage.getItem(user)),
      });
    },
  },
};
